import { formatPhoneNumber } from "../../shared/helpers";

export const TEAM_PAGE_SIZE = 10;

export const getMemberName = (member) => {
  const firstName = member?.Profiles?.FirstName;
  const lastName = member?.Profiles?.LastName;
  const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();

  return fullName || member?.FullName || member?.UserName || "Unknown Member";
};

export const getMemberInitials = (member) => {
  const name = getMemberName(member);

  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
};

export const getMemberRoles = (member) => {
  const roles = [];
  const profileRole = member?.Profiles?.RoleName || member?.Profiles?.Role;
  const topLevelRole = member?.RoleName || member?.Role || member?.JobTitle;

  if (profileRole) {
    roles.push(profileRole);
  }
  if (topLevelRole && !roles.includes(topLevelRole)) {
    roles.push(topLevelRole);
  }

  return roles.filter(Boolean);
};

export const getMemberPhone = (member) => {
  const phone =
    member?.PhoneNumber ||
    member?.MobilePhone ||
    member?.Profiles?.MobilePhone ||
    "";

  return phone ? formatPhoneNumber(phone) : "N/A";
};

export const flattenTeamMembers = ({ active = [], pending = [], inactive = [] }) =>
  [
    ...active.map((member) => ({ ...member, memberStatus: "Active" })),
    ...pending.map((member) => ({ ...member, memberStatus: "Pending" })),
    ...inactive.map((member) => ({ ...member, memberStatus: "Inactive" })),
  ];

export const filterTeamMembers = (members, query) => {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) {
    return members;
  }

  return members.filter((member) => {
    const haystack = [
      getMemberName(member),
      member?.EmailAddress,
      member?.JobTitle,
      getMemberPhone(member),
      ...getMemberRoles(member),
      member?.memberStatus,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return haystack.includes(normalizedQuery);
  });
};

export const paginateTeamMembers = (members, page, pageSize) => {
  const startIndex = (page - 1) * pageSize;

  return members.slice(startIndex, startIndex + pageSize);
};
